import { render, staticRenderFns } from "./QuestionBuilderForm.vue?vue&type=template&id=2d0e1188&"
import script from "./QuestionBuilderForm.vue?vue&type=script&lang=js&"
export * from "./QuestionBuilderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports